// extracted by mini-css-extract-plugin
export default {"imagesWrap":"FormItems_imagesWrap__je3Pv","imageBlock":"FormItems_imageBlock__t4tyv"};